<ng-container *ngIf="{
  row: columnData | async,
  adata: additionData | async
} as $">
    <button pButton pRipple type="button" icon="fa fa-angle-down" [label]="'common.BUTTONS.BTN_ACTIONS' | translate"
        iconPos="right" class="text-sm text-600 p-button-outlined p-button-secondary border-400 p-2"
        (click)="action.toggle($event)" aria-label="actions-button"></button>
    <p-popover #action styleClass="overflow-hidden text-sm w-10rem -ml-5" aria-label="actions-menu">
        <ng-template #content>
            <ul #listContainer class="list-none -m-4 py-2 px-0 text-xs text-600" role="menu">
                <li *ngIf="$.adata?.includes('edit')" (click)=" executeAction('edit',$.row,action) "
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="edit-action">
                    <i class="fa fa-pencil text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.EDIT' | translate }}
                </li>

                <li *ngIf="$.adata?.includes('status')" (click)="executeAction('status',$.row,action) "
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" [attr.aria-label]="'status-action-' + (isActive($.row) ? 'inactive' : 'active')">
                    <i class="text-xs mr-2" [ngClass]="isActive($.row) ? 'fa fa-eye-slash' : 'fa fa-eye' " aria-hidden="true"></i>
                    {{ 'Shared.TASK.TASK-CREATE.MARK' | translate }} {{isActive($.row)? 'In-active': 'Active'}}
                </li>

                <li *ngIf=" $.adata?.includes('delete')" (click)="executeAction('delete',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="delete-action">
                    <i class="fa fa-trash-alt text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.DELETE' | translate }}
                </li>

                <li *ngIf=" $.adata?.includes('print')" (click)=" executeAction('print',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="print-action">
                    <i class="fa fa-print mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.PRINT' | translate }}
                </li>

                <li *ngIf=" $.adata?.includes('sendemail')" (click)=" executeAction('sendemail',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="send-email-action">
                    <i class=" fa fa-envelope font-light mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.SENDEMAIL' | translate }}
                </li>

                <li *ngIf=" $.adata?.includes('sendwhatsapp')" (click)=" executeAction('sendwhatsapp',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="send-whatsapp-action">
                    <i class="fab fa-whatsapp mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.SEND_WHATSAPP' | translate }}
                </li>

                <li *ngIf=" $.adata?.includes('void') && !isStatusVoid($.row)"
                    (click)=" executeAction('void',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="void-action">
                    <i class="fa fa-ban mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.VOID' | translate }}
                </li>

                <li *ngIf=" $.adata?.includes('collectdues') &&  $.row.total_balance_due_in_minor_currency > 0"
                    (click)="executeAction('collectdues',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="collect-dues-action">
                    <i class="fa fa-money-bill mr-2" aria-hidden="true"></i>
                    {{ 'ADMIN.COMMON.COLLECTDUES' | translate }}
                </li>

                <li *ngIf=" $.adata?.includes('refundandsalesreturn') && (showSalesReturn | async)"
                    (click)=" executeAction('refundandsalesreturn',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="refund-sales-return-action">
                    <i class="fa fa-rotate-left mr-2" aria-hidden="true"></i>
                    {{ 'ADMIN.COMMON.REFUNDSALESRETURN' | translate }}
                </li>

                <li *ngIf=" $.adata.includes('changebillowner') "
                    [ngClass]="hasAdminBilling ? '':'opacity-40 pointer-events-none'"
                    (click)=" executeAction('changebillowner',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="change-bill-owner-action">
                    <i class="fa fa-user-edit mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.CHANGE_SALES_REP' | translate }}
                </li>

                <li *ngIf=" $.adata.includes('cancelTransfer') "
                    [ngClass]="hasAdminBilling ? '':'opacity-40 pointer-events-none'"
                    (click)=" executeAction('cancelTransfer',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="cancel-transfer-action">
                    <i class="fa fa-minus-circle mr-3" aria-hidden="true"></i> {{ 'ADMIN.COMMON.CANCEL_TRANSFER' | translate }}
                </li>

                <li *ngIf=" $.adata.includes('startTransfer')"
                    [ngClass]="hasAdminBilling ? '':'opacity-40 pointer-events-none'"
                    (click)=" executeAction('startTransfer',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="start-transfer-action">
                    <i class="fa fa-arrows-h mr-3" aria-hidden="true"></i> {{ 'ADMIN.COMMON.START_TRANSFER' | translate }}
                </li>

                <li *ngIf=" $.adata.includes('salesreturnvoid')"
                    (click)=" executeAction('salesreturnvoid',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="sales-return-void-action">
                    <i class="fa fa-ban mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.VOID' | translate }}
                </li>

                <li *ngIf=" $.adata.includes('refundvoid') && !isRefundStatusVoid($.row)"
                    (click)=" executeAction('refundvoid',$.row,action)"
                    [ngClass]="hasAdminBilling ? '':'opacity-40 pointer-events-none'"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="refund-void-action">
                    <i class="fa fa-ban mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.VOID' | translate }}
                </li>

                <li *ngIf=" $.adata.includes('refund') && (showRefund | async)  && showRefundOption($.row)"
                    (click)="executeAction('refund',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                    [ngClass]="hasAdminBilling ? '':'opacity-40 pointer-events-none'" role="menuitem" aria-label="refund-action">
                    <i class="fa fa-wallet mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.REFUND' | translate }}
                </li>

                <li *ngIf="$.adata.includes('selfsignup') && isActive($.row)"
                    (click)="executeAction('selfsignup',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="self-signup-action">
                    <i class="fa fa-qrcode text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.SELF_SIGN_UP' | translate }}
                </li>

                <li *ngIf="$.adata.includes('balanceclear') && isStatusPartialOrOpen($.row)"
                    (click)="executeAction('balanceclear',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="balance-clear-action">
                    <i class="fa fa-qrcode text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.DUE_LINK' | translate }}
                </li>

                <li *ngIf="$.adata.includes('changedate')"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                    (click)="executeAction('changedate',$.row,action)" role="menuitem" aria-label="change-date-action">
                    <i class="fa fa-calendar-alt text-xs mr-2" aria-hidden="true"></i>{{ 'ADMIN.COMMON.CHANGE_OPERATIONAL_DATE' | translate }}
                </li>

                <li [ngClass]="hasBalanceAmount($.row) && !isStatusVoid($.row) ? '' : 'opacity-40 pointer-events-none'" *ngIf="$.adata.includes('writeoff') && showWriteOff.value"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                    (click)="executeAction('writeoff',$.row,action)" role="menuitem" aria-label="writeoff-action">
                    <i class="fa fa-file-excel text-xs mr-2" aria-hidden="true"></i>{{ 'ADMIN.COMMON.WRITEOFF' | translate }}
                </li>

                <li *ngIf="$.adata?.includes('duplicate')" (click)=" executeAction('duplicate',$.row,action) "
                   class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="duplicate-action">
                   <i class="fa fa-copy text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.DUPLICATE' | translate }}
                </li>

                <li *ngIf="$.adata?.includes('convertContact')" (click)=" executeAction('convertContact',$.row,action) "
                   class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="convert-action">
                   <i class="fa fa-exchange-alt text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.CONVERTCONTACT' | translate }}
                </li>
                
                <li *ngIf="$.adata?.includes('stop_campaign') && showStopCampaign($.row)"
                    (click)="executeAction('stop_campaign',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="stop-campaign-action">
                    <i class="fa fa-stop-circle text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.STOP_CAMPAIGN' | translate }}
                </li>

                <li *ngIf="$.adata?.includes('void_campaign') && showVoidCampaign($.row)"
                    (click)="executeAction('void_campaign',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="void-campaign-action">
                    <i class="fa fa-ban text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.VOID_CAMPAIGN' | translate }}
                </li>   
                
            </ul>
        </ng-template>
    </p-popover>
</ng-container>